import { ExpenseItemCollection } from "types";

/**
 * 経費種類を取得します
 * @param itemList Contextから取得した経費種類情報
 * @param id 指定の経費種類Id
 * @returns 経費種類名
 */
export const GetItemName = (itemList: ExpenseItemCollection[], id: string) => {
  if (itemList === null || id === null) return "";
  const item = itemList.filter(f => f.id === id).shift();
  if (item) return item.name;
  return "";
};
